import classNames from "classnames";


export const TRANSITIONS = {
  overlay: {
    timeout: 150,
    classNames: {
      enter: 'opacity-0 scale-75',
      enterActive: 'opacity-100 !scale-100 transition-transform transition-opacity duration-150 ease-in',
      exit: 'opacity-100',
      exitActive: '!opacity-0 transition-opacity duration-150 ease-linear'
    }
  }
};

export const MenuPague = {
  root: 'py-1 bg-white dark:bg-gray-900 text-gray-700 dark:text-white/80 border border-gray-300 dark:border-blue-900/40 rounded-md w-60',
  menu: {
    className: classNames('m-0 p-0 list-none', 'outline-none')
  },
  content: ({ state, context }) => ({
    className: classNames(
      'text-gray-700 dark:text-white/80 transition-shadow duration-200 rounded-none ',
      {
        'hover:text-gray-700 dark:hover:text-white/80 hover:bg-gray-200 dark:hover:bg-gray-800/80': !context.item.disabled, // Hover
        'bg-white text-gray-700 dark:text-white/80 dark:bg-gray-800/90': state.focused,
        'cursor-default pointer-events-none select-none opacity-60': context.item.disabled
      }
    )
  }),
  action: {
    className: classNames('text-gray-700 dark:text-white/80 py-2 px-3 select-none', 'cursor-pointer flex items-center no-underline overflow-hidden relative')
  },
  menuitem: ({ context }) => ({
    className: classNames(
      { 'hover:bg-gray-200': !context.item.disabled }
    )
  }
  ),
  separator: 'border-t border-gray-300 dark:border-blue-900/40 my-1',
  transition: TRANSITIONS.overlay
}

export const MenuPagueNotificacao = {
  root: 'py-1 bg-white dark:bg-gray-900 text-gray-700 dark:text-white/80 border border-gray-300 dark:border-blue-900/40 rounded-md w-96',
  menu: {
    className: classNames('m-0 p-0 list-none', 'outline-none')
  },
  content: ({ state, context }) => ({
    className: classNames(
      'text-gray-700 dark:text-white/80 transition-shadow duration-200 rounded-none ',
      {
        'hover:text-gray-700 dark:hover:text-white/80 hover:bg-gray-200 dark:hover:bg-gray-800/80': !context.item.disabled, // Hover
        'bg-white text-gray-700 dark:text-white/80 dark:bg-gray-800/90': state.focused,
        'cursor-default pointer-events-none select-none opacity-60': context.item.disabled
      }
    )
  }),
  action: {
    className: classNames('text-gray-700 dark:text-white/80 py-2 px-3 select-none', 'cursor-pointer flex items-center no-underline overflow-hidden relative')
  },
  menuitem: ({ context }) => ({
    className: classNames(
      { 'hover:bg-gray-200': !context.item.disabled }
    )
  }
  ),
  separator: 'border-t border-gray-300 dark:border-blue-900/40 my-1',
  transition: TRANSITIONS.overlay
}

export const FloatLabelNumber = {
  root: {
    className: classNames(
      'block relative', // root component style
      '[&>label]:absolute [&>label]:pointer-events-none [&>label]:left-2 [&>label]:top-1/2 [&>label]:-mt-2 [&>label]:leading-none [&>label]:transition-all [&>label]:ease-in-out', // label style
      '[&>textarea]:top-4', // textarea
      '[&>span:has(>input:focus)~label]:-top-4 [&>span:has(>input:focus]:text-xs', // input focus
      '[&>span:has(>input:autofill)~label]:-top-4 [&>span:has(>input:autofill)~label]:text-xs', // input autofill
      '[&>span:has(>input.p-filled)~label]:-top-4 [&>span:has(>input.p-filled)~label]:text-xs', // input filled
      '[&>textarea:focus]:-top-4 [&>textarea:focus]:text-xs', // textarea focus
      '[&>textarea.p-filled]:-top-4 [&>textarea.p-filled]:text-xs', // textarea filled
      '[&>div[data-pc-name="dropdown"][data-p-focus="false"]]:-top-4 [&>div[data-pc-name="dropdown"][data-p-focus="false"]]:text-xs', // dropdown focus
      '[&>span:has(>input::placeholder)~label]:opacity-0 [&>span:has(>input::placeholder)~label]:transition-all [&>span:has(>input::placeholder)~label]:ease-in-out', // placeholder
      '[&>span:has(>input::placeholder:focus)~label]:opacity-100 [&>span:has(>input::placeholder:focus)~label]:transition-all [&>span:has(>input::placeholder:focus)~label]:ease-in-out' // placeholder focus
    )
  }
}

export const FloatLabelCalendar = {
  root: {
    className: classNames(
      'block relative', // root component style
      '[&>label]:absolute [&>label]:pointer-events-none [&>label]:left-2 [&>label]:top-1/2 [&>label]:-mt-2 [&>label]:leading-none [&>label]:transition-all [&>label]:ease-in-out', // label style
      '[&>textarea]:top-4', // textarea
      '[&>span:has(>input:focus)~label]:-top-4 [&>span:has(>input:focus]:text-xs', // input focus
      '[&>span:has(>input:autofill)~label]:-top-4 [&>span:has(>input:autofill)~label]:text-xs', // input autofill
      '[&>span:has(>input.p-filled)~label]:-top-4 [&>span:has(>input.p-filled)~label]:text-xs', // input filled
      '[&>span:has(>input:not(:placeholder-shown))~label]:-top-4 [&>span:has(>input:not(:placeholder-shown))~label]:text-xs', // input filled calendar
      '[&>textarea:focus]:-top-4 [&>textarea:focus]:text-xs', // textarea focus
      '[&>textarea.p-filled]:-top-4 [&>textarea.p-filled]:text-xs', // textarea filled
      '[&>div[data-pc-name="dropdown"][data-p-focus="false"]]:-top-4 [&>div[data-pc-name="dropdown"][data-p-focus="false"]]:text-xs', // dropdown focus
      '[&>span:has(>input::placeholder)~label]:opacity-0 [&>span:has(>input::placeholder)~label]:transition-all [&>span:has(>input::placeholder)~label]:ease-in-out', // placeholder
      '[&>span:has(>input::placeholder:focus)~label]:opacity-100 [&>span:has(>input::placeholder:focus)~label]:transition-all [&>span:has(>input::placeholder:focus)~label]:ease-in-out' // placeholder focus
    )
  }
}

export const FloatLabelPassword = {
  root: {
    className: classNames(
      'block relative', // root component style
      '[&>label]:absolute [&>label]:pointer-events-none [&>label]:left-2 [&>label]:top-1/2 [&>label]:-mt-2 [&>label]:leading-none [&>label]:transition-all [&>label]:ease-in-out', // label style
      '[&>textarea]:top-4', // textarea
      '[&>div:has(>div>input:focus)~label]:-top-4 [&>div:has(>div>input:focus]:text-xs', // input focus
      '[&>div:has(>div>input:autofill)~label]:-top-4 [&>div:has(>div>input:autofill)~label]:text-xs', // input autofill
      '[&>div:has(>div>input.p-filled)~label]:-top-4 [&>div:has(>div>input.p-filled)~label]:text-xs', // input filled
      '[&>textarea:focus]:-top-4 [&>textarea:focus]:text-xs', // textarea focus
      '[&>textarea.p-filled]:-top-4 [&>textarea.p-filled]:text-xs', // textarea filled
      '[&>div[data-pc-name="dropdown"][data-p-focus="false"]]:-top-4 [&>div[data-pc-name="dropdown"][data-p-focus="false"]]:text-xs', // dropdown focus
      '[&>div:has(>div>input::placeholder)~label]:opacity-0 [&>div:has(>div>input::placeholder)~label]:transition-all [&>div:has(>div>input::placeholder)~label]:ease-in-out', // placeholder
      '[&>div:has(>div>input::placeholder:focus)~label]:opacity-100 [&>div:has(>div>input::placeholder:focus)~label]:transition-all [&>div:has(>div>input::placeholder:focus)~label]:ease-in-out' // placeholder focus
    )
  }
}

export const ColorPickerPague = {
  root: ({ props }) => ({
    className: classNames('flex',
      {
        'opacity-60 select-none pointer-events-none cursor-default': props.disabled
      })
  }),
  input: {
    className: classNames(
      'm-0 w-full',
      'font-sans text-base text-gray-600 bg-white dark:bg-gray-900 p-3 border border-gray-300 dark:border-blue-900/40 transition-colors duration-200 rounded-lg cursor-pointer',
      'hover:border-blue-500 focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[0_0_0_0.2rem_rgba(147,197,253,0.5)]',
      'h-8'
    )
  },
  panel: ({ props }) => ({
    className: classNames('shadow-md', 'bg-gray-800 border-gray-900', {
      'relative h-48 w-52': props.inline,
      'absolute h-48 w-52': !props.inline
    })
  }),
  selector: 'absolute h-44 w-40 top-2 left-2',
  color: {
    className: 'h-44 w-40',
    style: { background: 'linear-gradient(to top, #000 0%, rgb(0 0 0 / 0) 100%), linear-gradient(to right, #fff 0%, rgb(255 255 255 / 0) 100%)' }
  },
  colorhandle: {
    className: classNames('rounded-full border border-solid cursor-pointer h-3 w-3 absolute  opacity-85', 'border-white')
  },
  hue: {
    className: 'h-44 w-6 absolute top-2 left-44 opacity-85',
    style: { background: 'linear-gradient(0deg, red 0, #ff0 17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, red)' }
  },
  huehandle: 'border-solid border-2 cursor-pointer h-2 w-8 left-0 -ml-1 -mt-1 opacity-85 absolute',
  transition: TRANSITIONS.overlay
}

export const ToggleButtonPague = {
  root: ({ props }) => ({
    className: classNames(
      'inline-flex cursor-pointer select-none items-center align-bottom text-center overflow-hidden relative',
      'px-4 py-3 rounded-md text-base w-36',
      'border transition duration-200 ease-in-out',
      {
        'bg-white dark:bg-gray-900 border-gray-300 dark:border-blue-900/40 text-gray-700 dark:text-white/80 hover:bg-gray-100 dark:hover:bg-gray-800/80 hover:border-gray-300 dark:hover:bg-gray-800/70 hover:text-gray-700 dark:hover:text-white/80':
          !props.checked,
        'bg-blue-500 border-blue-500 text-white hover:bg-blue-600 hover:border-blue-600': props.checked
      },
      { 'opacity-60 select-none pointer-events-none cursor-default': props.disabled }
    )
  }),
  label: 'font-bold text-center w-full',
  icon: ({ props }) => ({
    className: classNames(' mr-2', {
      'text-gray-600 dark:text-white/70': !props.checked,
      'text-white': props.checked
    })
  })
}

export const ButtonPagueDefault = {
  root: ({ context }) => ({
    className: classNames(
      'bg-[#192945] hover:bg-sky-800 border-0 w-full',
      'dark:bg-pague_verde dark:hover:bg-pague_verde_claro flex',
      'p-3 rounded-lg text-white dark:text-white transition duration-200',
      'items-center cursor-pointer inline-flex overflow-hidden relative select-none text-center align-bottom',
      'transition duration-200 ease-in-out',
      'focus:outline-none focus:outline-offset-0',
      { 'opacity-60 pointer-events-none cursor-default': context.disabled }
    )
  }),
  loadingIcon: ({ props }) => ({
    className: classNames('mx-0', {
      'mr-2': props.loading && props.iconPos == 'left' && props.label != null,
      'ml-2 order-1': props.loading && props.iconPos == 'right' && props.label != null,
      'mb-2': props.loading && props.iconPos == 'top' && props.label != null,
      'mt-2 order-2': props.loading && props.iconPos == 'bottom' && props.label != null
    })
  }),
}

export const CalendarPague = {
  root: ({ props }) => ({
    className: classNames(
      props.className,
      "w-full flex",
      {
        'md:w-1/2 w-full': props.className === 'painelAdimplencia',
      }
    )
  }),
  input: ({ props }) => ({
    root: {
      className: classNames('font-sans text-base text-gray-600',
        'dark:text-white/80 bg-white dark:bg-gray-900 p-3',
        'border border-gray-300 dark:border-blue-900/40',
        'transition-colors duration-200 appearance-none',
        'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[0_0_0_0.2rem_rgba(147,197,253,0.5)]',
        'hover:border-blue-500',
        {
          'rounded-lg w-full': !props.showIcon,
          'border-r-0 rounded-l-lg w-5/6': props.showIcon,
          'border-r-0 rounded-l-lg !w-11/12': props.showIcon && props.className === 'cadastroBoletoAdimplencia',
          'border-r-0 rounded-l-lg w-full': props.showIcon && props.className === 'formularioAdimplencia',
        })
    }
  }),
  select: 'dark:bg-sky-500 dark:text-black bg-gray-300 rounded pl-1',
  dropdownButton: {
    root: ({ props }) => ({
      className: classNames({ 'rounded-l-none': props.icon })
    }),
    label: 'hidden'
  },
}

export const DropdownInputGroup = {
  root: ({ props }) => ({
    className: classNames(
      'cursor-pointer inline-flex relative select-none h-12',
      'bg-white border border-gray-400 transition-colors duration-200 ease-in-out rounded-l-md',
      'dark:bg-gray-900 dark:border-blue-900/40 dark:hover:border-blue-300',
      'w-full md:w-56',
      'hover:border-blue-500 focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[0_0_0_0.2rem_rgba(147,197,253,0.5)]',
      { 'opacity-60 select-none pointer-events-none cursor-default': props.disabled }
    )
  }),
  itemLabel: 'font-semibold',
  item: ({ context }) => ({
    className: classNames(
      'cursor-pointer font-normal overflow-hidden relative whitespace-nowrap',
      'm-0 p-3 border-0  transition-shadow duration-200 rounded-none',
      'dark:text-white/80 dark:hover:bg-gray-700 dark:hover:text-white',
      'hover:text-gray-900 hover:bg-gray-200 hover:font-bold',
      {
        'text-gray-700': !context.focused && !context.selected,
        'bg-gray-300 text-gray-700 dark:text-white/80 dark:bg-gray-800/90': context.focused && !context.selected,
        'bg-blue-100 text-blue-700 dark:bg-sky-800 dark:text-white/80': context.focused && context.selected,
        'bg-blue-50 text-blue-700 dark:bg-sky-700 dark:text-white/80': !context.focused && context.selected,
        'opacity-60 select-none pointer-events-none cursor-default': context.disabled
      }
    )
  }),
  // select: 'rounded-full'
}

export const InputNumberPague = {
  root: "w-full",
  input: {
    root: ({ props, context }) => ({
      className: classNames(
        'm-0 w-full',
        'font-sans text-gray-600 dark:text-white/80 bg-white dark:bg-gray-900 border transition-colors duration-200 appearance-none rounded-lg',
        {
          'transition-opacity duration-300 focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[0_0_0_0.2rem_rgba(147,197,253,0.5)]':
            !context.disabled,
          'hover:border-blue-500': !props.invalid && !context.disabled,
          'transition-opacity duration-300 opacity-60 select-none pointer-events-none cursor-default': context.disabled,
          'border-gray-300 dark:border-blue-900/40': !props.invalid,
          'border-red-500 hover:border-red-500/80 focus:border-red-500':
            props.invalid && !context.disabled,
          'border-red-500/50': props.invalid && context.disabled,
        },
        {
          'text-lg px-4 py-4': props.size === 'large',
          'text-xs px-2 py-2': props.size === 'small',
          'p-3 text-base': !props.size || typeof props.size === 'number'
        },
        {
          'pl-8': context.iconPosition === 'left',
          'pr-8': props.iconPosition === 'right'
        }
      ),
    })
  },
}

export const PasswordFullPague = {
  root: ({ props }) => ({
    className: classNames('grid relative w-full', {
      'opacity-60 select-none pointer-events-none cursor-default': props.disabled
    })
  }),
  input: 'w-full'
}

export const DataTablePague = {
  root: ({ props }) => ({
    className: classNames('relative', {
      'flex flex-col h-full': props.scrollable && props.scrollHeight === 'flex'
    })
  }),
  loadingoverlay: {
    className: classNames(
      'fixed w-full h-full t-0 l-0 bg-gray-100/40',
      'transition duration-200',
      'absolute flex items-center justify-center z-[100]',
      'dark:bg-gray-950/40' // Dark Mode
    )
  },
  loadingicon: 'w-8 h-8',
  wrapper: ({ props }) => ({
    className: classNames({
      relative: props.scrollable,
      'flex flex-col grow h-full': props.scrollable && props.scrollHeight === 'flex'
    })
  }),
  header: ({ props }) => ({
    className: classNames(
      'bg-transparent text-slate-700 border-none font-bold p-4',
      'dark:border-none dark:text-white/80 dark:bg-transparent', // Dark Mode
      props.showGridlines ? 'border-x border-t border-b-0' : 'border-y border-x-0'
    )
  }),
  table: 'w-full border-spacing-0',
  footer: {
    className: classNames(
      'bg-slate-50 text-slate-700 border-t-0 border-b border-x-0 border-gray-300 font-bold p-4',
      'dark:border-blue-900/40 dark:text-white/80 dark:bg-gray-900' // Dark Mode
    )
  },
  paginator: {
    firstpagebutton: ({ context }) => ({
      className: classNames(
        'relative inline-flex items-center justify-center user-none overflow-hidden leading-none',
        'border-0 text-gray-500  min-w-[3rem] h-12 m-[0.143rem] rounded-md',
        'hover:bg-slate-200 dark:hover:bg-sky-900',
        'transition duration-200',
        'dark:text-white', //Dark Mode
        {
          'cursor-default pointer-events-none opacity-60': context.disabled,
          'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)]': !context.disabled // Focus
        }
      )
    }),
    previouspagebutton: ({ context }) => ({
      className: classNames(
        'relative inline-flex items-center justify-center user-none overflow-hidden leading-none',
        'border-0 text-gray-500 min-w-[3rem] h-12 m-[0.143rem] rounded-md',
        'hover:bg-slate-200 dark:hover:bg-sky-900',
        'transition duration-200',
        'dark:text-white', //Dark Mode
        {
          'cursor-default pointer-events-none opacity-60': context.disabled,
          'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)]': !context.disabled // Focus
        }
      )
    }),
    nextpagebutton: ({ context }) => ({
      className: classNames(
        'relative inline-flex items-center justify-center user-none overflow-hidden leading-none',
        'border-0 text-gray-500 min-w-[3rem] h-12 m-[0.143rem] rounded-md',
        'hover:bg-slate-200 dark:hover:bg-sky-900',
        'transition duration-200',
        'dark:text-white', //Dark Mode
        {
          'cursor-default pointer-events-none opacity-60': context.disabled,
          'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)]': !context.disabled // Focus
        }
      )
    }),
    lastpagebutton: ({ context }) => ({
      className: classNames(
        'relative inline-flex items-center justify-center user-none overflow-hidden leading-none',
        'border-0 text-gray-500 min-w-[3rem] h-12 m-[0.143rem] rounded-md',
        'hover:bg-slate-200 dark:hover:bg-sky-900',
        'transition duration-200',
        'dark:text-white', //Dark Mode
        {
          'cursor-default pointer-events-none opacity-60': context.disabled,
          'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)]': !context.disabled // Focus
        }
      )
    }),
    pagebutton: ({ context }) => ({
      className: classNames(
        'relative inline-flex items-center justify-center user-none overflow-hidden leading-none',
        'border-0 text-gray-500 min-w-[3rem] h-12 m-[0.143rem] rounded-md',
        'transition duration-200 ',
        'hover:bg-slate-200 dark:hover:bg-sky-900',
        'dark:border-blue-300 dark:text-white', // Dark Mode
        'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)]', // Focus
        {
          'font-bold bg-blue-50 border-blue-50 text-blue-700 dark:bg-sky-700': context.active
        }
      )
    }),
  },
  column: {
    headercell: ({ context, props }) => ({
      className: classNames(
        'text-left border-0 border-b border-solid border-gray-300 dark:border-blue-900/40 font-bold',
        'transition duration-200',
        context?.size === 'small' ? 'p-2' : context?.size === 'large' ? 'p-5' : 'p-4', // Size
        context.sorted ? 'bg-blue-50 text-blue-700' : 'bg-slate-50 text-slate-700', // Sort
        context.sorted ? 'dark:text-white/80 dark:bg-blue-300' : 'dark:text-white/80 dark:bg-gray-900', // Dark Mode
        {
          'sticky z-[1]': props.frozen || props.frozen === '', // Frozen Columns
          'border-x border-y': context?.showGridlines,
          'overflow-hidden space-nowrap border-y relative bg-clip-padding': context.resizable // Resizable
        }
      )
    }),
    headercontent: 'flex items-center',
    bodycell: ({ props, context }) => ({
      className: classNames(
        'bg-card dark:bg-card_dark',
        'text-left border-0 border-b border-solid border-gray-300',
        context?.size === 'small' ? 'p-2' : context?.size === 'large' ? 'p-5' : 'p-4', // Size
        'dark:text-white/80 dark:border-blue-900/40', // Dark Mode
        {
          'sticky bg-inherit': props && (props.frozen || props.frozen === ''), // Frozen Columns
          'border-x border-y': context.showGridlines
        }
      )
    }),
    footercell: ({ context }) => ({
      className: classNames(
        'text-left border-0 border-b border-solid border-gray-300 font-bold',
        'bg-slate-50 text-slate-700',
        'transition duration-200',
        context?.size === 'small' ? 'p-2' : context?.size === 'large' ? 'p-5' : 'p-4', // Size
        'dark:text-white/80 dark:bg-gray-900 dark:border-blue-900/40', // Dark Mode
        {
          'border-x border-y': context.showGridlines
        }
      )
    }),
    bodyrow: ({ context }) => ({
      className: classNames(
        context.selected ? 'bg-blue-50 text-blue-700 dark:bg-blue-300' : 'bg-white text-gray-600 dark:bg-gray-900',
        context.stripedRows ? (context.index % 2 === 0 ? 'bg-white text-gray-600 dark:bg-gray-900' : 'bg-blue-50/50 text-gray-600 dark:bg-gray-950') : '',
        'transition duration-200',
        'focus:outline focus:outline-[0.15rem] focus:outline-blue-200 focus:outline-offset-[-0.15rem]', // Focus
        'dark:text-white/80 dark:focus:outline dark:focus:outline-[0.15rem] dark:focus:outline-blue-300 dark:focus:outline-offset-[-0.15rem]', // Dark Mode
        {
          'cursor-pointer': context.selectable,
          'hover:bg-gray-300/20 hover:text-gray-600': context.selectable && !context.selected // Hover
        }
      )
    }),
    rowexpansion: 'bg-white text-gray-600 dark:bg-blue-900 dark:text-white/80',
    rowgrouptoggler: {
      className: classNames(
        'text-left m-0 p-0 cursor-pointer select-none',
        'inline-flex items-center justify-center overflow-hidden relative',
        'w-8 h-8 text-gray-500 border-0 bg-transparent rounded-[50%]',
        'transition duration-200',
        'dark:text-white/70' // Dark Mode
      )
    },
    rowgrouptogglericon: 'inline-block w-4 h-4',
    resizehelper: 'absolute hidden w-px z-10 bg-blue-500 dark:bg-blue-300',
  }
}

export const LargeTablePague = {
  root: ({ props }) => ({
    className: classNames('relative grid', {
      'flex flex-col h-full': props.scrollable && props.scrollHeight === 'flex'
    })
  }),
  loadingoverlay: {
    className: classNames(
      'fixed w-full h-full t-0 l-0 bg-gray-100/40',
      'transition duration-200',
      'absolute flex items-center justify-center z-[100]',
      'dark:bg-gray-950/40' // Dark Mode
    )
  },
  wrapper: ({ props }) => ({
    className: classNames(
      'overflow-scroll '
      , {
        'relative': props.scrollable,
        'flex flex-col grow h-full': props.scrollable && props.scrollHeight === 'flex'
      })
  }),
  loadingicon: 'w-8 h-8',
  header: ({ props }) => ({
    className: classNames(
      'bg-transparent text-slate-700 border-none font-bold p-4',
      'dark:border-none dark:text-white/80 dark:bg-transparent', // Dark Mode
      props.showGridlines ? 'border-x border-t border-b-0' : 'border-y border-x-0'
    )
  }),
  table: 'table-fixed border-collapse min-w-full',
  footer: {
    className: classNames(
      'bg-slate-50 text-slate-700 border-t-0 border-b border-x-0 border-gray-300 font-bold p-4',
      'dark:border-blue-900/40 dark:text-white/80 dark:bg-gray-900' // Dark Mode
    )
  },
  column: {
    bodycell: ({ props, context }) => ({
      className: classNames(
        ' md:text-wrap text-md', //'max-w-56 overflow-hidden text-ellipsis whitespace-nowrap',
        'text-left border-0 border-b border-solid border-gray-300',
        context?.size === 'small' ? 'p-2' : context?.size === 'large' ? 'p-5' : 'p-4', // Size
        'dark:text-white/80 dark:border-blue-900/40', // Dark Mode
        {
          'sticky bg-inherit': props && (props.frozen || props.frozen === ''), // Frozen Columns
          'border-x border-y': context.showGridlines
        }
      )
    }),
  },
  paginator: {
    firstPageButton: ({ context }) => ({
      className: classNames(
        'relative inline-flex items-center justify-center user-none overflow-hidden leading-none',
        'border-0 text-gray-500  min-w-[3rem] h-12 m-[0.143rem] rounded-md',
        'transition duration-200',
        'dark:text-white', //Dark Mode
        {
          'hover:bg-slate-200 dark:hover:bg-sky-900': !context.disabled,
          'cursor-default pointer-events-none opacity-60': context.disabled,
          'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)]': !context.disabled // Focus
        }
      )
    }),
    prevPageButton: ({ context }) => ({
      className: classNames(
        'relative inline-flex items-center justify-center user-none overflow-hidden leading-none',
        'border-0 text-gray-500 min-w-[3rem] h-12 m-[0.143rem] rounded-md',
        'transition duration-200',
        'dark:text-white', //Dark Mode
        {
          'hover:bg-slate-200 dark:hover:bg-sky-900': !context.disabled,
          'cursor-default pointer-events-none opacity-60': context.disabled,
          'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)]': !context.disabled // Focus
        }
      )
    }),
    nextPageButton: ({ context }) => ({
      className: classNames(
        'relative inline-flex items-center justify-center user-none overflow-hidden leading-none',
        'border-0 text-gray-500 min-w-[3rem] h-12 m-[0.143rem] rounded-md',
        'transition duration-200',
        'dark:text-white', //Dark Mode
        {
          'hover:bg-slate-200 dark:hover:bg-sky-900': !context.disabled,
          'cursor-default pointer-events-none opacity-60': context.disabled,
          'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)]': !context.disabled // Focus
        }
      )
    }),
    lastPageButton: ({ context }) => ({
      className: classNames(
        'relative inline-flex items-center justify-center user-none overflow-hidden leading-none',
        'border-0 text-gray-500 min-w-[3rem] h-12 m-[0.143rem] rounded-md',
        'transition duration-200',
        'dark:text-white', //Dark Mode
        {
          'hover:bg-slate-200 dark:hover:bg-sky-900': !context.disabled,
          'cursor-default pointer-events-none opacity-60': context.disabled,
          'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)]': !context.disabled // Focus
        }
      )
    }),
    pageButton: ({ context }) => ({
      className: classNames(
        'relative inline-flex items-center justify-center user-none overflow-hidden leading-none',
        'border-0 text-gray-500 min-w-[3rem] h-12 m-[0.143rem] rounded-md',
        'transition duration-200 ',
        'hover:bg-slate-200 dark:hover:bg-sky-900',
        'dark:border-blue-300 dark:text-white', // Dark Mode
        'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)]', // Focus
        {
          'font-bold bg-blue-50 border-blue-50 text-blue-700 dark:bg-sky-700': context.active
        }
      )
    }),
  },
}

export const TreeTablePague = {
  root: ({ props }) => ({
    className: classNames('relative grid', {
      'flex flex-col h-full': props.scrollable && props.scrollHeight === 'flex'
    })
  }),
  loadingoverlay: {
    className: classNames(
      'fixed w-full h-full t-0 l-0 bg-gray-100/40',
      'transition duration-200',
      'absolute flex items-center justify-center z-[100]',
      'dark:bg-gray-950/40' // Dark Mode
    )
  },
  wrapper: ({ props }) => ({
    className: classNames(
      'overflow-x-scroll '
      , {
        'relative': props.scrollable,
        'flex flex-col grow h-full': props.scrollable && props.scrollHeight === 'flex'
      })
  }),
  loadingicon: 'w-8 h-8',
  header: ({ props }) => ({
    className: classNames(
      'bg-transparent text-slate-700 border-none font-bold p-4',
      'dark:border-none dark:text-white/80 dark:bg-transparent', // Dark Mode
      props.showGridlines ? 'border-x border-t border-b-0' : 'border-y border-x-0'
    )
  }),
  table: 'table-fixed border-collapse min-w-full',
  footer: {
    className: classNames(
      'bg-slate-50 text-slate-700 border-t-0 border-b border-x-0 border-gray-300 font-bold p-4',
      'dark:border-blue-900/40 dark:text-white/80 dark:bg-gray-900' // Dark Mode
    )
  },
  column: {
    bodycell: ({ props, context }) => ({
      className: classNames(
        ' md:text-nowrap text-md',
        'text-left border-0 border-b border-solid border-gray-300',
        context?.size === 'small' ? 'p-2' : context?.size === 'large' ? 'p-5' : 'p-4', // Size
        'dark:text-white/80 dark:border-blue-900/40', // Dark Mode
        {
          'sticky bg-inherit': props && (props.frozen || props.frozen === ''), // Frozen Columns
          'border-x border-y': context.showGridlines
        }
      )
    }),
    headercell: ({ context, props }) => ({
      className: classNames(
        'text-left border-0 border-b border-solid border-gray-300 dark:border-blue-900/40 font-bold',
        'transition duration-200',
        context?.size === 'small' ? 'p-2' : context?.size === 'large' ? 'p-5' : 'p-4', // Size
        context.sorted ? 'bg-blue-50 text-blue-700' : 'bg-slate-50 text-slate-700', // Sort
        context.sorted ? 'dark:text-white/80 dark:bg-blue-300' : 'dark:text-white/80 dark:bg-gray-900', // Dark Mode
        {
          'sticky z-[1]': props.frozen || props.frozen === '', // Frozen Columns
          'border-x border-y': context?.showGridlines,
          'overflow-hidden space-nowrap border-y relative bg-clip-padding': context.resizable // Resizable
        }
      )
    }),
  },
  paginator: {
    firstpagebutton: ({ context }) => ({
      className: classNames(
        'relative inline-flex items-center justify-center user-none overflow-hidden leading-none',
        'border-0 text-gray-500  min-w-[3rem] h-12 m-[0.143rem] rounded-md',
        'hover:bg-slate-200 dark:hover:bg-sky-900',
        'transition duration-200',
        'dark:text-white', //Dark Mode
        {
          'cursor-default pointer-events-none opacity-60': context.disabled,
          'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)]': !context.disabled // Focus
        }
      )
    }),
    previouspagebutton: ({ context }) => ({
      className: classNames(
        'relative inline-flex items-center justify-center user-none overflow-hidden leading-none',
        'border-0 text-gray-500 min-w-[3rem] h-12 m-[0.143rem] rounded-md',
        'hover:bg-slate-200 dark:hover:bg-sky-900',
        'transition duration-200',
        'dark:text-white', //Dark Mode
        {
          'cursor-default pointer-events-none opacity-60': context.disabled,
          'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)]': !context.disabled // Focus
        }
      )
    }),
    nextpagebutton: ({ context }) => ({
      className: classNames(
        'relative inline-flex items-center justify-center user-none overflow-hidden leading-none',
        'border-0 text-gray-500 min-w-[3rem] h-12 m-[0.143rem] rounded-md',
        'hover:bg-slate-200 dark:hover:bg-sky-900',
        'transition duration-200',
        'dark:text-white', //Dark Mode
        {
          'cursor-default pointer-events-none opacity-60': context.disabled,
          'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)]': !context.disabled // Focus
        }
      )
    }),
    lastpagebutton: ({ context }) => ({
      className: classNames(
        'relative inline-flex items-center justify-center user-none overflow-hidden leading-none',
        'border-0 text-gray-500 min-w-[3rem] h-12 m-[0.143rem] rounded-md',
        'hover:bg-slate-200 dark:hover:bg-sky-900',
        'transition duration-200',
        'dark:text-white', //Dark Mode
        {
          'cursor-default pointer-events-none opacity-60': context.disabled,
          'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)]': !context.disabled // Focus
        }
      )
    }),
    pagebutton: ({ context }) => ({
      className: classNames(
        'relative inline-flex items-center justify-center user-none overflow-hidden leading-none',
        'border-0 text-gray-500 min-w-[3rem] h-12 m-[0.143rem] rounded-md',
        'transition duration-200 ',
        'hover:bg-slate-200 dark:hover:bg-sky-900',
        'dark:border-blue-300 dark:text-white', // Dark Mode
        'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)]', // Focus
        {
          'font-bold bg-blue-50 border-blue-50 text-blue-700 dark:bg-sky-700': context.active
        }
      )
    }),
  },
}

export const PaginatorPague = {
  firstPageButton: ({ context }) => ({
    className: classNames(
      'relative inline-flex items-center justify-center user-none overflow-hidden leading-none',
      'border-0 text-gray-500  min-w-[3rem] h-12 m-[0.143rem] rounded-md',
      'transition duration-200',
      'dark:text-white', //Dark Mode
      {
        'hover:bg-slate-200 dark:hover:bg-sky-900': !context.disabled,
        'cursor-default pointer-events-none opacity-60': context.disabled,
        'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)]': !context.disabled // Focus
      }
    )
  }),
  prevPageButton: ({ context }) => ({
    className: classNames(
      'relative inline-flex items-center justify-center user-none overflow-hidden leading-none',
      'border-0 text-gray-500 min-w-[3rem] h-12 m-[0.143rem] rounded-md',
      'transition duration-200',
      'dark:text-white', //Dark Mode
      {
        'hover:bg-slate-200 dark:hover:bg-sky-900': !context.disabled,
        'cursor-default pointer-events-none opacity-60': context.disabled,
        'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)]': !context.disabled // Focus
      }
    )
  }),
  nextPageButton: ({ context }) => ({
    className: classNames(
      'relative inline-flex items-center justify-center user-none overflow-hidden leading-none',
      'border-0 text-gray-500 min-w-[3rem] h-12 m-[0.143rem] rounded-md',
      'transition duration-200',
      'dark:text-white', //Dark Mode
      {
        'hover:bg-slate-200 dark:hover:bg-sky-900': !context.disabled,
        'cursor-default pointer-events-none opacity-60': context.disabled,
        'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)]': !context.disabled // Focus
      }
    )
  }),
  lastPageButton: ({ context }) => ({
    className: classNames(
      'relative inline-flex items-center justify-center user-none overflow-hidden leading-none',
      'border-0 text-gray-500 min-w-[3rem] h-12 m-[0.143rem] rounded-md',
      'transition duration-200',
      'dark:text-white', //Dark Mode
      {
        'hover:bg-slate-200 dark:hover:bg-sky-900': !context.disabled,
        'cursor-default pointer-events-none opacity-60': context.disabled,
        'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)]': !context.disabled // Focus
      }
    )
  }),
  pageButton: ({ context }) => ({
    className: classNames(
      'relative inline-flex items-center justify-center user-none overflow-hidden leading-none',
      'border-0 text-gray-500 min-w-[3rem] h-12 m-[0.143rem] rounded-md',
      'transition duration-200 ',
      'hover:bg-slate-200 dark:hover:bg-sky-900',
      'dark:border-blue-300 dark:text-white', // Dark Mode
      'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)]', // Focus
      {
        'font-bold bg-blue-50 border-blue-50 text-blue-700 dark:bg-sky-700': context.active
      }
    )
  }),
}

export const DropdownPague = {
  root: ({ props }) => ({
    className: classNames(
      'cursor-pointer inline-flex relative select-none',
      'bg-white border border-gray-400 transition-colors duration-200 ease-in-out rounded-md',
      'dark:bg-gray-900 dark:border-blue-900/40 dark:hover:border-blue-300',
      'hover:border-blue-500 focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[0_0_0_0.2rem_rgba(147,197,253,0.5)]',
      {
        'opacity-60 select-none pointer-events-none cursor-default': props.disabled,
        'w-full md:w-56': !props.className,
        'lg:w-1/2 w-full': props.className === 'painelAdimplencia',
        'w-full': props.className === 'parametrosAdimplencia'
      }
    )
  }),
  filtercontainer: 'relative flex items-center',
  filterinput: {
    className: classNames(
      'pr-7 -mr-7 ',
      'w-full',
      'font-sans text-base text-gray-700 bg-white py-3 px-7 border border-gray-300 transition duration-200 rounded-lg appearance-none',
      'dark:bg-gray-900 dark:border-blue-900/40 dark:hover:border-blue-300 dark:text-white/80',
      'hover:border-blue-500 focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[0_0_0_0.2rem_rgba(147,197,253,0.5)]'
    )
  },
  filtericon: 'absolute w-auto px-2',
  itemLabel: 'font-semibold',
  item: ({ context }) => ({
    className: classNames(
      'cursor-pointer font-normal overflow-hidden relative lg:whitespace-nowrap',
      'm-0 p-3 border-0  transition-shadow duration-200 rounded-none',
      'dark:text-white/80 dark:hover:bg-gray-700 dark:hover:text-white',
      'hover:text-gray-900 hover:bg-gray-200 hover:font-bold',
      {
        'text-gray-700': !context.focused && !context.selected,
        'bg-gray-300 text-gray-700 dark:text-white/80 dark:bg-gray-800/90': context.focused && !context.selected,
        'bg-blue-100 text-blue-700 dark:bg-sky-800 dark:text-white/80': context.focused && context.selected,
        'bg-blue-50 text-blue-700 dark:bg-sky-700 dark:text-white/80': !context.focused && context.selected,
        'opacity-60 select-none pointer-events-none cursor-default': context.disabled
      }
    )
  }),
  // select: 'rounded-full'
}

export const ConfirmDialogPague = {
  root: {
    className: classNames(
      'bg-white text-gray-700 border-0 rounded-md shadow-lg',
      'z-40 transform origin-center',
      'mt-3 absolute left-[40%] top-[40%]',
      'dark:border dark:border-blue-900/40 dark:bg-gray-900  dark:text-white/80'
    )
  },
  content: 'p-5 items-center flex',
  transition: TRANSITIONS.overlay
}


